import {Base} from '../../common/model/base.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Contesto} from '../contesto/contesto.model';
import {TipoEntitaOrganizzativa} from '../tipoentitaorganizzativa/tipoentitaorganizzativa.model';
import {TipoRuolo} from './tipo-ruolo.enum';
import {TranslateService} from '@ngx-translate/core';

export class Ruolo extends Base {

  constructor(protected id: number,
              public descr: string,
              public sigla: string,
              public padre: number,
              public assegnabileGlobalmente: boolean,
              public indennita: boolean,
              public soal: boolean,
              public contesto: Contesto,
              public tipoRuolo: TipoRuolo,
              public contestiVisualizzatore: Contesto[],
              public tipiEntitaOrganizzativa: TipoEntitaOrganizzativa[],
              public ruoliAssociati: Ruolo[],
              public ruoliGruppoAssociati: Ruolo[],
              public ruoliAssegnati: Ruolo[],
              public ruoliGruppoAssegnati: Ruolo[]) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'descr', 'sigla', 'contesto', 'tipoRuolo'];
  }

  public getLabel(detailed?: Boolean) {
    return this.descr;
  }

  public getContesti() {
    return this.contesto.descr
  }

  public toTableRow(translate?: TranslateService): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('descr', new TableRowValue(this.descr, null));
    rowValues.set('sigla', new TableRowValue(this.sigla, null));
    rowValues.set('contesto', new TableRowValue(this.contesto.getLabel(), null));
    translate.get(this.tipoRuolo.getEnumValue()).subscribe((res: string)=>{
      rowValues.set('tipoRuolo', new TableRowValue(res, null));
    });
    return new TableRow(this, rowValues);
  }

}
